import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

import Phaser from './phaser.vue';
import ControlOverlay from './components/control-overlay.vue';
import GameBackground from 'src/components/game-background.vue';
import { useModule } from 'src/modules/modules';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { global, theme } = useModule();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(Phaser),
        _createVNode(ControlOverlay, null, {
          default: _withCtx(() => [
            _createVNode(_Transition, {
              name: _unref(global).sceneState.transitionClass,
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (!_unref(global).sceneState.exiting && _unref(global).activeSceneKey)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(global).activeSceneKey), {
                      key: _unref(global).sceneState.scene
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["name"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})